import { useTranslation } from "react-i18next";

import { DownloadIcon,ExcelIcon } from "../../../../assets/icons";

const TemplateSheets = () => {
  const { t, i18n } = useTranslation();

  const language = i18n.language.includes("en") ? "en-US" : "zh";
  const singleTemplateFilePath = `assets/Cleaning_Template_${language}.xlsx`;
  const multiTemplateFilePath = `assets/Multi_Train_Cleaning_Template_${language}.xlsx`;

  const downloadTemplate = (path, fileName) => {
    const a = document.createElement("a");
    a.href = path;
    a.download = fileName + ".xlsx";
    a.click();
  };

  return (
    <div>
      <div className="subHeading">{t("analyseData.templateSheets")}</div>

      <div className="template-sheets-panel__list">
        <div className="template-sheets-panel__item">
          <span className="template-sheets-panel__item-content">
            <ExcelIcon className="template-sheets-panel__excel-icon" />
            <span>{t("analyseData.singleTrainPlant")}</span>
          </span>
          <DownloadIcon
            className="template-sheets-panel__download-icon"
            onClick={() =>
              downloadTemplate(
                singleTemplateFilePath,
                t("excelSheetNames.cleaningTemplate"),
              )
            }
          />
        </div>

        <div className="template-sheets-panel__item">
          <span className="template-sheets-panel__item-content">
            <ExcelIcon className="template-sheets-panel__excel-icon" />
            <span>{t("analyseData.multiTrainPlant")}</span>
          </span>
          <DownloadIcon
            className="template-sheets-panel__download-icon"
            onClick={() =>
              downloadTemplate(
                multiTemplateFilePath,
                t("excelSheetNames.multiTrainCleaningTemplate"),
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateSheets;
